import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import useTranslation from "next-translate/useTranslation";
import HeroEllipse from "./HeroEllipse";
import { useRouter } from "next/router";

const DownloadSetups = () => {
  // Fonction de téléchargement
  const handleDownload = (os) => {
    // URLs des fichiers de téléchargement
    const downloadUrls = {
      windows: "https://github.com/Global-IT-Service/watchman-desktop-setups/releases/download/v1.0.2/Watchman-1.0.2-win32-x64.exe",
      linux: "https://github.com/Global-IT-Service/watchman-desktop-setups/releases/download/v1.0.2/Watchman-1.0.2-linux-x64.deb",
      mac: "https://github.com/Global-IT-Service/watchman-desktop-setups/releases/download/v1.0.2/Watchman-1.0.2-mac-x64.dmg",
    };

    // Crée un lien invisible pour déclencher le téléchargement
    const link = document.createElement("a");
    link.href = downloadUrls[os];
    link.download = true;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const router = useRouter();
  const { t } = useTranslation();
  const { colorMode } = useColorMode();

  return (
    <Stack
      as={"section"}
      zIndex={1}
      isolation={"isolate"}
      bg={colorMode === "light" ? "transparent" : "#021b17"}
      px={{ "2xl": "120px", "5xl": "450px" }}
      w={{ base: "100vw", "2xl": "full" }}
      justifyContent={"center"}
      align={{ "2xl": "center" }}
      spacing={{ base: "24px", "2xl": "50px" }}
      position={"relative"}
    >
      <HeroEllipse />
      {/* Heading  */}
      <Heading textAlign={"center"} color={colorMode === "light" ? "inherit" : "#00B295"} fontSize={{ base: "36px", "5xl": "38px" }} fontWeight={"bold"}>
       {t("home:download.title")}
      </Heading>
      {/* Paragraphs  */}
      <Text textAlign={"center"} color={colorMode === "light" ? "black" : "white"} px={{ base: "Opx", xl: "150px" }}>
         {t("home:download.description")}
      </Text>

      {/* Buttons de téléchargement */}
      <Flex zIndex={"9"} gap="50px" flexWrap="wrap" justifyContent="center" mt={10}>
        <Button _hover={{
          bg: colorMode === "light" ? "brand.200" : "brand.300",
          color: "white"
        }} cursor={"pointer"} onClick={() => handleDownload("windows")}>
          <Image src="/icons/windows.png" mr="10px" height={"20px"} alt="Windows logo" /> 
           {t("home:download.button.windows")}
        </Button>
        <Button
        _hover={{
          bg: colorMode === "light" ? "brand.200" : "brand.300",
          color: "white"
        }}
        disabled={true} // Disable the Linux button
        cursor={"pointer"} onClick={() => handleDownload("linux")}>
          <Image src="/icons/linux.png" mr="10px" height={"20px"} alt="Linux logo" /> 
          {t("home:download.button.linux")}
        </Button>
        <Button
        _hover={{
          bg: colorMode === "light" ? "brand.200" : "brand.300",
          color: "white"
        }}
        disabled={true} // Disable the Mac button
        cursor={"pointer"} onClick={() => handleDownload("mac")}>
          <Image src="/icons/apple.png" mr="10px" height={"20px"} alt="Mac logo" /> 
          {t("home:download.button.macos")}
        </Button>
      </Flex>
    </Stack>
  );
};

export default DownloadSetups;